<template>
  <a-modal
    ref="createModal"
    title="派工"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 1600}"
    >
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(typeList, record)">删除</a>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              :dropdown-match-select-width="false"
              @change="selectChange(record, item.dataIndex)"
            />
          </span>
          <span v-else-if="item.type === 'date'">
            <a-date-picker
              v-model="record[item.dataIndex]"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiMesDispatchAdd } from '@/api/mes/workOrderManage/workOrderSent'
import deepClone from "lodash.clonedeep";
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          title: '工单号',
          width: 100,
          dataIndex: 'wipEntityName'
        },
        {
          title: '工单状态',
          width: 80,
          dataIndex: 'statusName'
        },
        {
          title: '成品',
          width: 100,
          dataIndex: 'itemCode'
        },
        {
          title: '规格描述',
          width: 100,
          dataIndex: 'description',
          ellipsis: true
        },
        {
          title: '工单分类',
          width: 80,
          dataIndex: 'classCode',
          ellipsis: true
        },
        {
          title: '单位',
          width: 50,
          dataIndex: 'primaryUomCode'
        },
        {
          title: '计划数量',
          width: 80,
          dataIndex: 'planQuantity',
          scopedSlots: { customRender: 'planQuantity' },
          type: "inputNumber"
        },
        {
          title: '车间',
          width: 120,
          dataIndex: 'workCode',
          scopedSlots: { customRender: 'workCode' },
          type: "select",
          setParams: true,
          requestApi: "/mes/mesDiscreteJobs/workCodeBox",
          value: 'realValue',
          label: 'label'
        },
        {
          title: '产线',
          width: 120,
          dataIndex: 'lineId',
          scopedSlots: { customRender: 'lineId' },
          type: "select",
          setParams: true,
          requestApi: "/mes/mesDiscreteJobs/lineCodeBox",
          value: 'realValue',
          label: 'label'
        },
        {
          title: '计划开始时间',
          width: 150,
          dataIndex: 'scheduledStartDate',
          scopedSlots: { customRender: 'scheduledStartDate' },
          type: "date"
        },
        {
          title: '计划完成时间',
          width: 150,
          dataIndex: 'scheduledCompletionDate',
          scopedSlots: { customRender: 'scheduledCompletionDate' },
          type: "date"
        },
        {
          title: '操作',
          width: 80,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      typeList: [],
      originTableList: []
    }
  },
  created () {

  },
  methods: {
    moment,
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (val) {
      this.originTableList = deepClone(val)
      val[0].indexId = 1
      this.typeList = val
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const originData = deepClone(this.originTableList)
      const obj = {
        wipEntityName: originData[0].wipEntityName,
        statusName: originData[0].statusName,
        itemCode: originData[0].itemCode,
        description: originData[0].description,
        classCode: originData[0].classCode,
        primaryUomCode: originData[0].primaryUomCode,
        planQuantity: "",
        workCode: "",
        lineId: "",
        scheduledStartDate: "",
        scheduledCompletionDate: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
      this.$emit('handle-success')
    },
    // 保存
    confirm () {
      let flag = false
      let totalQuantity = 0
      for (let i = 0; i < this.typeList.length; i++) {
        totalQuantity += Number(this.typeList[i].planQuantity)
        if (!this.typeList[i].planQuantity ||
        !this.typeList[i].workCode ||
        !this.typeList[i].lineId ||
        !this.typeList[i].scheduledStartDate ||
        !this.typeList[i].scheduledCompletionDate) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      if (totalQuantity !== this.originTableList[0].planQuantity) {
        this.$message.warning('修改后的计划数量不等于原数量')
        return false
      }
      this.confirmLoading = true

      const arr = JSON.parse(JSON.stringify(this.typeList))
      const arr4 = []
      const arr3 = []
      arr.forEach(element => {
        element.scheduledStartDate = this.$moment(element.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss')
        element.scheduledCompletionDate = this.$moment(element.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        delete element.createTime
        delete element.updateTime
        arr3.push(element)
      });
      arr4.push(arr3)

      apiMesDispatchAdd(arr4).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    },
    selectChange (record, dataIndex) {
      if (dataIndex === "workCode") {
        record.lineId = undefined
      }
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "workCode") {
        return { organizationCode: this.originTableList[0].desOrganizationCode }
      }
      if (dataIndex === "lineId") {
        return { workCode: record.workCode }
      }
    },
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 140px;
}
/deep/.ant-modal-body{
  height: 600px;
  overflow-y: scroll;
}
/deep/.ant-input-number{
  width: 80px;
}
/deep/.ant-calendar-picker{
  min-width: 170px !important;
}
</style>
